import { createApiClient, apiClient } from "./apiClient";

export interface LoginHistoryPayload {
  lastLoggedAt: string;
  clientTimeZone: string;
  clientTimeStamp: string;
  deviceType: string;
}

const LOGIN_HISTORY_ENDPOINT = "/common/login-history";

export const recordLoginHistory = async (
  payload: LoginHistoryPayload
): Promise<void> => {
  const api = createApiClient();
  await apiClient(api, LOGIN_HISTORY_ENDPOINT, "POST", payload);
};
